// ***WYSIWYG SHOPIFY***
const cWysiwygShopify = {
  init: function () {
    // shopify - add wysiwyg styling to policy text
    const shopifyPolicyBody = document.querySelector(".shopify-policy__body");
    if (shopifyPolicyBody) {
      shopifyPolicyBody.firstElementChild.classList.add(
        "wysiwyg",
        "wysiwyg-page"
      );
    }

    // shopify - remove meta information
    document
      .querySelectorAll(".wysiwyg meta[charset], .wysiwyg-page meta[charset]")
      .forEach((el) => el.remove());
  },
};

// ***ITEM VARIANTS***
const cItemVariants = {
  updateVariantPillCurrentSelection: function (variantSelector, value, label) {
    const variantGroup = variantSelector.closest(".js-variant-group");
    const selected = variantGroup.querySelector(".js-variant-pills-selected");

    if (selected) {
      selected.dataset.label = value;
      selected.dataset.labelCurrent = label;
    }
  },
  init: function () {
    // on('body', 'mouseover', '.js-variant-group .js-variant-selector', (e) => {
    // 	const target = e.target.closest('.js-variant-selector');
    // 	this.updateVariantPillCurrentSelection(
    // 		target,
    // 		target.value,
    // 		target.dataset.label
    // 	);
    // });
    // on('body', 'mouseout', '.c-product-form .js-variant-selector', (e) => {
    // 	const target = e.target.closest('.js-variant-selector');
    // 	this.updateVariantPillCurrentSelection(target, '', '');
    // });
  },
};

// ***ITEM SELLING PLAN***
const cItemSellingPlan = {
  init: function () {
    on(
      "body",
      "change",
      '.c-item-selling-plan input[type="radio"][name*="selling-plan-"]',
      (e) => {
        const target = e.target.closest(
          'input[type="radio"][name*="selling-plan-"]'
        );
        const sellingPlanComponent = target.closest(".c-item-selling-plan");

        const selector = sellingPlanComponent.querySelector(
          ".c-item-selling-plan__option-select"
        );

        // if subscription is not selected, set selling_plan selector to disabled
        if (selector) {
          selector.disabled = target.value == "subscription" ? false : true;
        }
      }
    );
  },
};

// ***ITEM QUANTITY***
const cItemQuantity = {
  updateQuantity: function (itemQuantity, increase) {
    const input = itemQuantity.querySelector('input[name="quantity"]');
    const inputDecrease = itemQuantity.querySelector(
      '[data-trigger="decrease"]'
    );
    const inputIncrease = itemQuantity.querySelector(
      '[data-trigger="increase"]'
    );

    // update input
    const value = parseInt(input.value);
    const valueChange =
      increase === true
        ? value + 1 <= parseInt(input.max)
          ? 1
          : 0
        : value - 1 >= parseInt(input.min)
        ? -1
        : 0;
    const newValue = value + (increase !== undefined ? valueChange : 0);
    const newValueFormatted =
      input.dataset.leadingZero == "true" ? formatPad(newValue) : newValue;

    // button disabled state
    inputDecrease.disabled = newValue <= input.min ? true : false;
    inputIncrease.disabled = newValue >= input.max ? true : false;

    // input value has changed!
    if (newValueFormatted != input.value) {
      input.value = newValueFormatted;

      const eventChange = new Event("change");
      input.dispatchEvent(eventChange);
    }
  },
  init: function () {
    on("body", "click", ".c-item-quantity [data-trigger]", (e) => {
      const target = e.target.closest("[data-trigger]");
      const itemQuantity = target.closest(".c-item-quantity");

      this.updateQuantity(itemQuantity, target.dataset.trigger == "increase");
    });
  },
};

// ***PRODUCT FORM***
const cProductForm = {
  formatPrice: function (price) {
    if (!price) return false;

    // account for commas and decimals
    // "$10,100.99 USD" => ['$', 10100.99, 'USD']
    const regex = /([^0-9]*)([0-9,]+[\\\\.\\\\,]?[0-9]*)([^0-9]*)/;
    const match = price.match(regex);
    const result = [
      match[1],
      parseFloat(match[2].replace(/[\\\\,]/g, "")),
      match[3],
    ];
    return result;
  },

  updateVariantPillCurrentSelection: function (variantSelector, value, label) {
    const variantGroup = variantSelector.closest(".js-variant-group");
    const selected = variantGroup.querySelector(".js-variant-pills-selected");

    if (selected) {
      selected.dataset.label = value;
      selected.dataset.labelCurrent = label;
    }
  },

  saveVariantSelection: function (form, selection, variantsJson) {
    const variantSelectors = form.querySelectorAll(".js-variant-selector");

    // save variantTitle
    variantSelectors.forEach((el) => {
      const isInput = el.tagName == "INPUT";
      const title = isInput ? (el.checked ? el.value : false) : el.value;

      if (title) {
        selection["variantTitle"].push(title);
        this.updateVariantPillCurrentSelection(el, el.value, el.dataset.label);
      }
    });

    // save variantObject
    selection["variantIndex"] = variantsJson.findIndex((object) => {
      return object.title === selection["variantTitle"].join(" / ");
    });
    selection["variantObject"] = variantsJson[selection["variantIndex"]];
  },

  updatePrice: function (form, variantObject) {
    const priceComponents = form.querySelectorAll(".c-item-price");
    priceComponents.forEach((priceComponent) => {
      const priceAdj = parseFloat(priceComponent.dataset.regularPriceAdj) || 1;
      const priceRegular = priceComponent.querySelector(".js-price-regular");
      const variantPrice = variantObject.price;

      if (priceRegular) {
        const [currency, value, decimal] = this.formatPrice(variantPrice);
        const formattedPrice = `${currency}${formatNumberCommas(
          ((value + decimal) * priceAdj).toFixed(2)
        ).replace(".00", "")}`;
        priceRegular.innerText = formattedPrice;
      }

      const priceCompare = priceComponent.querySelector(".js-price-compare");
      if (priceCompare) {
        const priceCompareValue = this.formatPrice(
          variantObject.priceCompare
        )[1];
        const priceRegularValue = this.formatPrice(variantObject.price)[1];

        priceCompare.innerText =
          priceCompareValue > priceRegularValue
            ? variantObject.priceCompare
            : "";
      }
    });
  },

  updateQuantity: function (form, variantObject) {
    const maxInventory = variantObject.inventory;
    const inputQuantity = form.querySelector('input[name="quantity"]');

    // set max inventory
    if (inputQuantity) inputQuantity.max = maxInventory;

    // prevent quantity from going over variant max inventory
    if (parseInt(inputQuantity.value) > maxInventory && maxInventory != 0) {
      inputQuantity.value = maxInventory;
    }

    // dispatch update event to quantity component
    const quantityComponent = form.querySelector(".c-item-quantity");
    cItemQuantity.updateQuantity(quantityComponent);
  },

  updateFormId: function (form, variantObject) {
    const inputId = form.querySelector('input[name="id"]');

    inputId.value = variantObject.id;
  },

  updateFormSubmitState: function (form, variantObject) {
    const formSubmit = form.querySelector(".js-form-submit");

    // Sync the Eko gallery player to the newly-selected variant.
    //
    // Why this is more than a single API call:
    //  1. Eko's iframe loads asynchronously; on a fast variant change
    //     after page load `window.eko.gallery.setVariant` can still be
    //     undefined, and the optional-chained call silently no-ops.
    //  2. Eko's iframe URL encodes variant by *title* in the hash
    //     (`#variantId=Carbon`/`Cream`), not by Shopify variant id.
    //     Calling with the numeric id was inconsistent — sometimes
    //     ignored, sometimes mapped via Eko's own lookup.
    //  3. Variant changes trigger Eko to re-insert a fresh iframe
    //     (which our MutationObserver in `initEkoHybridGalleries` then
    //     re-patches). During that window the API binding can be
    //     mid-transition.
    //
    // Strategy: try the title first, then the id, and retry over a
    // ~3s window if the API isn't on `window.eko` yet.
    (function syncEkoVariant(attempts) {
      attempts = attempts || 0;
      const setVariant = window.eko && window.eko.gallery && window.eko.gallery.setVariant;
      if (typeof setVariant !== "function") {
        if (attempts < 15) {
          setTimeout(function () { syncEkoVariant(attempts + 1); }, 200);
        }
        return;
      }
      try {
        if (variantObject.title) setVariant.call(window.eko.gallery, variantObject.title);
        if (variantObject.id)    setVariant.call(window.eko.gallery, variantObject.id);
      } catch (err) {
        console.warn("[Eko] setVariant failed:", err);
      }
    })();
    if (variantObject.id == 50448645685559) {
      form.dataset.available = true;
      formSubmit.disabled = false;

      document
        .querySelectorAll(".form-state-available")
        .forEach((el) => el.classList.add("hide"));
      document
        .querySelectorAll(".form-state-sold-out")
        .forEach((el) => el.classList.add("hide"));
      document
        .querySelectorAll(".form-state-preorder")
        .forEach((el) => el.classList.remove("hide"));
      document
        .querySelectorAll(".preorder-expected")
        .forEach((el) => el.classList.remove("hide"));
    } else if (variantObject.inventory <= 0) {
      document
        .querySelectorAll(".form-state-available")
        .forEach((el) => el.classList.add("hide"));
      document
        .querySelectorAll(".form-state-sold-out")
        .forEach((el) => el.classList.remove("hide"));
      document
        .querySelectorAll(".form-state-preorder")
        .forEach((el) => el.classList.add("hide"));
      document
        .querySelectorAll(".back-in-stock-wrap")
        .forEach((el) => el.classList.add("show"));
      document
        .querySelectorAll(".preorder-expected")
        .forEach((el) => el.classList.add("hide"));
      form.dataset.available = false;
      if (formSubmit && document.querySelector("[data-waitlist-modal]")) {
        formSubmit.disabled = false;
        formSubmit.type = "button";
        formSubmit.setAttribute("aria-disabled", "true");
        formSubmit.setAttribute("data-waitlist-trigger", "");
        formSubmit.dataset.productHandle = form.dataset.productHandle || "";
        formSubmit.dataset.productTitle = form.dataset.productTitle || "";
        formSubmit.dataset.productId = form.dataset.productId || "";
        if (formSubmit.dataset.productTitle) {
          formSubmit.setAttribute(
            "aria-label",
            `Sold Out — Notify Me about ${formSubmit.dataset.productTitle}`
          );
        }
      } else if (formSubmit) {
        formSubmit.disabled = true;
        formSubmit.type = "submit";
        formSubmit.removeAttribute("aria-disabled");
        formSubmit.removeAttribute("data-waitlist-trigger");
      }
    } else {
      document
        .querySelectorAll(".form-state-available")
        .forEach((el) => el.classList.remove("hide"));
      document
        .querySelectorAll(".form-state-sold-out")
        .forEach((el) => el.classList.add("hide"));
      document
        .querySelectorAll(".form-state-preorder")
        .forEach((el) => el.classList.add("hide"));
      document
        .querySelectorAll(".back-in-stock-wrap")
        .forEach((el) => el.classList.remove("show"));
      document
        .querySelectorAll(".preorder-expected")
        .forEach((el) => el.classList.add("hide"));
      form.dataset.available = true;
      if (formSubmit) {
        formSubmit.disabled = false;
        formSubmit.type = "submit";
        formSubmit.removeAttribute("aria-disabled");
        formSubmit.removeAttribute("data-waitlist-trigger");
      }
    }

    // update backorder notice
    document
      .querySelectorAll(".product-hero__backorder-notice")
      .forEach((el) => {
        if (el.getAttribute("data-id") === variantObject.id) {
          el.classList.add("product-hero__backorder-notice--active");
        } else {
          el.classList.remove("product-hero__backorder-notice--active");
        }
      });
  },
  updateUrl: function (variantObject) {
    window.history.replaceState({}, "", `?variant=${variantObject.id}`);
  },
  updateVariantDisabledState: function (formElement, variants) {
    const variantGroups = formElement.querySelectorAll(".js-variant-group");
    const inStockVariants = variants.filter((variant) => variant.inventory > 0);

    // disable if there's only one variant group
    if (variantGroups.length <= 1) return false;

    // Get an array of selected variant values for each variant group
    const selectedVariants = Array.from(variantGroups).map((variantGroup) => {
      const isInput = variantGroup.querySelector("input.js-variant-selector");
      const selection = variantGroup.querySelector(
        `.js-variant-selector${isInput ? ":checked" : ""}`
      );

      return selection && selection.value != "" ? selection.value : false;
    });

    if (selectedVariants.includes(false)) return false;

    // Loop through each variant group
    // & disable the unselected variant if the combination is not in stock
    Array.from(variantGroups).forEach((variantGroup, index) => {
      const isInput = variantGroup.querySelector("input.js-variant-selector");
      // Find all unselected variants in the group
      const unselectedVariants = variantGroup.querySelectorAll(
        `.js-variant-selector${
          !isInput ? " option:not(:checked)" : ":not(:checked)"
        }`
      );

      unselectedVariants.forEach((unselectedVariant) => {
        // Create a new array of variant values with the current unselected variant included
        const selectedVariantValues = [...selectedVariants];
        selectedVariantValues[index] = unselectedVariant.value;

        // Check if the combination of variant values is in stock
        const combinationInStock = inStockVariants.some((variant) => {
          const selectedVariantTitles = selectedVariantValues.join(" / ");
          // Check if the variant title matches the selected variant values
          return variant.title === selectedVariantTitles;
        });

        // Disable the unselected variant if the combination is not in stock
        unselectedVariant.disabled = !combinationInStock;

        // Update the text of the unselected variant to indicate if it is sold out
        if (unselectedVariant.tagName === "OPTION") {
          unselectedVariant.innerText = `${unselectedVariant.value}${
            combinationInStock ? "" : " - sold out"
          }`;
        }
      });
    });
  },
  init: function () {
    document.querySelectorAll(".c-product-form").forEach((form) => {
      if (form.dataset.updateVariantDisabledState == "true") {
        const variantsJson = validateJson(
          form.dataset.variantsJson.replace(/'/g, '"').trim()
        );
        this.updateVariantDisabledState(form, variantsJson);
      }
    });

    on("body", "change", ".c-product-form .js-variant-selector", (e) => {
      const target = e.target.closest(".js-variant-selector");
      const form = target.closest(".c-product-form");
      const variantsJson = validateJson(
        form.dataset.variantsJson.replace(/'/g, '"').trim()
      );
      const selection = {
        selectorIndex: null,
        variantTitle: [],
        variantIndex: null,
        variantObject: null,
      };

      // save selection in object
      if (form && variantsJson) {
        this.saveVariantSelection(form, selection, variantsJson);
      }

      // trigger updates based on selected variant
      const selectedVariant = selection["variantObject"];
      if (form && selectedVariant) {
        this.updatePrice(form, selectedVariant);
        this.updateQuantity(form, selectedVariant);
        this.updateFormId(form, selectedVariant);
        this.updateFormSubmitState(form, selectedVariant);

        if (form.dataset.updateVariantUrl == "true") {
          this.updateUrl(selectedVariant);
        }

        if (form.dataset.updateVariantDisabledState == "true") {
          this.updateVariantDisabledState(form, variantsJson);
        }
      }

      if (target.classList.contains("js-dropdown-color-selector")) {
        const selectedOption = target.querySelector(
          `option[value="${target.value}"]`
        );
        if (selectedOption) {
          target.style.backgroundColor =
            selectedOption.getAttribute("data-color");
        }
      }
    });

    // Color swatches are native radio inputs (checked state comes from the
    // input itself), so no aria-pressed management is needed here.

    // Color selector keyboard navigation
    on("body", "keydown", ".color-swatch-new__label", (e) => {
      const label = e.target.closest(".color-swatch-new__label");
      const colorGroup = label.closest(".c-item-variants__pills");
      if (!colorGroup) return;

      const allLabels = Array.from(
        colorGroup.querySelectorAll(".color-swatch-new__label")
      );
      const currentIndex = allLabels.indexOf(label);
      let targetIndex;

      switch (e.key) {
        case "Enter":
        case " ": // Space
          e.preventDefault();
          label.click();
          break;
        case "ArrowRight":
        case "ArrowDown":
          e.preventDefault();
          targetIndex = (currentIndex + 1) % allLabels.length;
          break;
        case "ArrowLeft":
        case "ArrowUp":
          e.preventDefault();
          targetIndex =
            (currentIndex - 1 + allLabels.length) % allLabels.length;
          break;
        case "Home":
          e.preventDefault();
          targetIndex = 0;
          break;
        case "End":
          e.preventDefault();
          targetIndex = allLabels.length - 1;
          break;
        default:
          return;
      }

      if (targetIndex !== undefined) {
        allLabels[targetIndex].focus();
      }
    });

    on("body", "submit", 'form[action="/early-access"]', (e) => {
      e.preventDefault();
      const form = e.target.closest('form[action="/early-access"]');

      loader.updateProgress(root);
      form?.classList.add("is-show-early-access-error");

      setTimeout(() => {
        loader.complete(root);
      }, 1000);
    });

    // New quantity selectors
    document.querySelectorAll(".quantity-selector").forEach((selector) => {
      const quantityInput = selector.querySelector("input[name='quantity']");
      const plusButton = selector.querySelector(
        ".quantity-selector__button--plus"
      );
      const minusButton = selector.querySelector(
        ".quantity-selector__button--minus"
      );

      plusButton.addEventListener("click", () => {
        quantityInput.value = parseInt(quantityInput.value) + 1;
        updateCapsules(quantityInput);
      });

      minusButton.addEventListener("click", () => {
        const currentValue = parseInt(quantityInput.value);
        if (currentValue > 1) {
          quantityInput.value = currentValue - 1;
          updateCapsules(quantityInput);
        }
      });
    });

    const updateCapsules = (input) => {
      function formatPrice(cents) {
        let dollars = (cents / 100).toFixed(2); // Convert to dollars with 2 decimal places
        return dollars.endsWith(".00")
          ? `$${parseInt(dollars)}` // Remove .00 if it exists
          : `$${dollars}`; // Otherwise, keep the decimal part
      }

      const unit = input.getAttribute("data-unit");
      const size = input.getAttribute("data-size");
      const price = input.getAttribute("data-price");
      const capsules = document.querySelector(".new-coffee-capsules");

      if (unit && size && price && capsules) {
        const newSize = Number(input.value) * Number(size);
        const newPrice = Number(input.value) * Number(price);

        const str = `${newSize} ${unit}s - ${formatPrice(newPrice)}`;

        capsules.textContent = str;
      }
    };

    // Scroll listener for sticky product forms
    const throttle = (fn, wait) => {
      let lastTime = 0;
      return function (...args) {
        const now = new Date().getTime();
        if (now - lastTime >= wait) {
          fn.apply(this, args);
          lastTime = now;
        }
      };
    };

    const handleScroll = throttle(() => {
      const stickyForms = document.querySelectorAll(".c-product-form--sticky");
      const scrollY = window.scrollY || window.pageYOffset;

      stickyForms.forEach((form) => {
        // Find the regular (non-sticky) add to cart form to calculate threshold
        const regularFormContainer = document.querySelector(
          ".product-hero__info__bottom"
        );
        let threshold = 1200; // Default threshold if we can't find the regular form

        if (regularFormContainer) {
          const containerRect = regularFormContainer.getBoundingClientRect();
          const containerBottom = containerRect.bottom + scrollY;
          // Show sticky form only after the regular form has scrolled past the viewport bottom
          // Add 100px buffer to ensure smooth transition
          threshold = containerBottom - window.innerHeight + 100;
        }

        if (scrollY >= threshold) {
          form.classList.add("c-product-form--active");
        } else {
          form.classList.remove("c-product-form--active");
        }
      });
    }, 100); // Throttle the scroll event to fire once every 100ms

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Recalculate on resize in case layout changes
    window.addEventListener("resize", handleScroll);
  },
};

// ***ITEM QUANTITY***
const cProductHero = {
  activateTab: function (tabButton) {
    if (!tabButton) return;
    const btn = tabButton.closest
      ? tabButton.closest(".product-hero-tabs__tab")
      : tabButton;
    if (!btn) return;

    const tab = btn.getAttribute("data-tab");
    const activeCls = "product-hero-tabs__tab--active";
    const bodyActiveCls = "product-hero-tabs__body--active";
    const container = btn.closest
      ? btn.closest(".product-hero-tabs") || document
      : document;

    // Remove active state from current tab and panel
    const currentActiveTab = container.querySelector(`.${activeCls}`);
    const currentActivePanel = container.querySelector(`.${bodyActiveCls}`);

    if (currentActiveTab) {
      currentActiveTab.classList.remove(activeCls);
      currentActiveTab.setAttribute("aria-selected", "false");
    }

    if (currentActivePanel) {
      currentActivePanel.classList.remove(bodyActiveCls);
    }

    // Add active state to new tab and panel
    btn.classList.add(activeCls);
    btn.setAttribute("aria-selected", "true");

    const newActivePanel = container.querySelector(
      `.product-hero-tabs__body[data-tab="${tab}"]`
    );
    if (newActivePanel) {
      newActivePanel.classList.add(bodyActiveCls);

      // Focus the first meaningful content element for better screen reader experience
      // Try to find a heading first, then a paragraph, then fall back to the panel itself
      const firstHeading = newActivePanel.querySelector(
        "h1, h2, h3, h4, h5, h6"
      );
      const firstParagraph = newActivePanel.querySelector("p");
      const firstList = newActivePanel.querySelector("ul, ol");

      if (firstHeading) {
        // Make heading focusable temporarily if it isn't already
        if (!firstHeading.hasAttribute("tabindex")) {
          firstHeading.setAttribute("tabindex", "-1");
        }
        firstHeading.focus();
      } else if (firstParagraph) {
        // Make paragraph focusable temporarily if it isn't already
        if (!firstParagraph.hasAttribute("tabindex")) {
          firstParagraph.setAttribute("tabindex", "-1");
        }
        firstParagraph.focus();
      } else if (firstList) {
        // Make list focusable temporarily if it isn't already
        if (!firstList.hasAttribute("tabindex")) {
          firstList.setAttribute("tabindex", "-1");
        }
        firstList.focus();
      } else {
        // Fall back to focusing the panel itself
        newActivePanel.focus();
      }
    }
  },

  init: function () {
    // Tab click events
    on(".product-hero-tabs__tab", "click", ".product-hero-tabs__tab", (e) => {
      this.activateTab(e.target);
    });

    // Tab keyboard events
    on(".product-hero-tabs__tab", "keydown", ".product-hero-tabs__tab", (e) => {
      const tabList =
        (e.target.closest && e.target.closest(".product-hero-tabs__tabs")) ||
        document;
      const tabButtons = Array.from(
        tabList.querySelectorAll(".product-hero-tabs__tab")
      );
      const currentIndex = tabButtons.indexOf(e.target);

      switch (e.key) {
        case "Enter":
        case " ": // Space
          e.preventDefault();
          this.activateTab(e.target);
          break;
        case "ArrowRight":
        case "ArrowDown":
          e.preventDefault();
          const nextIndex = (currentIndex + 1) % tabButtons.length;
          tabButtons[nextIndex].focus();
          break;
        case "ArrowLeft":
        case "ArrowUp":
          e.preventDefault();
          const prevIndex =
            (currentIndex - 1 + tabButtons.length) % tabButtons.length;
          tabButtons[prevIndex].focus();
          break;
        case "Home":
          e.preventDefault();
          tabButtons[0].focus();
          break;
        case "End":
          e.preventDefault();
          tabButtons[tabButtons.length - 1].focus();
          break;
      }
    });

    // Upsells
    on("body", "submit", ".product-hero-upsell__form", (e) => {
      e.preventDefault();
      e.stopPropagation(); // Prevent bubbling to other handlers

      let formData = new FormData(e.target);

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          cCart.updateCartContent();
          cCart.announceCartUpdate("Item added to cart");
          cCart.minicartOpen();
        })
        .catch((error) => {
          console.error("Error adding upsell product to cart:", error);
        });
    });

    var upsellSwiper = new Swiper(".swiper-container", {
      navigation: {
        nextEl: ".product-hero-upsells__nav-right",
        prevEl: ".product-hero-upsells__nav-left",
      },
      pagination: {
        el: ".product-hero-upsells__pagination",
        clickable: true,
        // CCH-35: render bullets as real <button>s so AT gets a proper
        // name, role, and state (Swiper adds aria-label + aria-current)
        bulletElement: "button",
      },
      slidesPerView: 1,
    });
  },
};

// ***CART***
const cCart = {
  // cart level updates
  updateCartStats: function () {
    fetch("/cart.js")
      .then(function (response) {
        return response.json();
      })
      .then((data) => {
        const itemCount = data.item_count;

        const cart = document.querySelector(".c-cart");

        itemCount > 0
          ? root.classList.remove("is-cart-empty")
          : root.classList.add("is-cart-empty");

        document.querySelectorAll(".js-cart-item-count").forEach((el) => {
          el.innerText = itemCount;
        });

        // update cart total
        const cartPrice = data.items_subtotal_price / 100;
        const cartPriceFormatted = `${formatNumberCommas(
          cartPrice.toFixed(2)
        ).replace(".00", "")}`;

        document.querySelectorAll(".js-cart-total-price").forEach((el) => {
          el.innerText = `$${cartPriceFormatted}`;
        });
        this.updateShippingStatus(cart, cartPrice);
        this.updateFreeShippingStatus(cart, cartPrice);

        this.initUpsell();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  },
  updateShippingStatus: function (cart, cartPrice) {
    const shippingMinimum = cart.getAttribute("data-shipping-minimum");
    const checkoutBtn = document.querySelector(".js-checkout-btn");
    const shippingUnlockedMsg = document.querySelector(
      ".js-shipping-unlocked-msg"
    );
    const machineMsg = document.querySelector(".js-machine-msg");
    const cartStatus = document.querySelector(".js-cart-shipping-status");

    const machineItem = cart.querySelector('[data-item-id="9790561714487"]');

    try {
      if (machineItem && !machineItem.classList.contains("is-removed")) {
        machineMsg?.classList.add("is-active");
        cart.querySelector(".js-machine-bullet").classList.add("is-active");
      } else {
        machineMsg?.classList.remove("is-active");
        cart.querySelector(".js-machine-bullet").classList.remove("is-active");
      }
    } catch (err) {}

    // when order meets shipping minimum
    if (cartPrice >= shippingMinimum) {
      checkoutBtn.disabled = false;
      shippingUnlockedMsg?.classList.add("is-active");
      cartStatus && cartStatus.classList.remove("is-active");
    }
    // when order doesn't meet shipping minimum
    else {
      checkoutBtn.disabled = true;
      shippingUnlockedMsg?.classList.remove("is-active");
      cartStatus && cartStatus.classList.add("is-active");
      const shippingDifferenceEls = document.querySelectorAll(
        ".js-cart-shipping-difference"
      );
      const statusBar =
        cartStatus && cartStatus.querySelector(".js-cart-shipping-progress");

      const shippingDifference = shippingMinimum - cartPrice;

      for (let item of shippingDifferenceEls) {
        item.innerHTML = shippingDifference;
      }

      // update free shipping status progress bar
      if (statusBar) {
        statusBar.style.width = `${(cartPrice / shippingMinimum) * 100}%`;
      }
    }
  },
  updateFreeShippingStatus: function (cart, cartPrice) {
    const shippingMinimum = cart.getAttribute("data-free-shipping-minimum");
    const shippingUnlockedMsg = document.querySelector(
      ".js-free-shipping-unlocked-msg"
    );
    const cartStatus = document.querySelector(".js-cart-free-shipping-status");

    // when order meets shipping minimum
    if (cartPrice >= shippingMinimum) {
      shippingUnlockedMsg?.classList.add("is-active");
      cartStatus && cartStatus.classList.remove("is-active");
    }
    // when order doesn't meet shipping minimum
    else {
      shippingUnlockedMsg?.classList.remove("is-active");
      cartStatus && cartStatus.classList.add("is-active");
      const shippingDifferenceEls = document.querySelectorAll(
        ".js-cart-free-shipping-difference"
      );
      const statusBar =
        cartStatus &&
        cartStatus.querySelector(".js-cart-free-shipping-progress");

      const shippingDifference = shippingMinimum - cartPrice;

      for (let item of shippingDifferenceEls) {
        item.innerHTML = shippingDifference;
      }

      // update free shipping status progress bar
      if (statusBar) {
        statusBar.style.width = `${(cartPrice / shippingMinimum) * 100}%`;
      }
    }
  },
  updateCartContent: function () {
    const carts = document.querySelectorAll(".c-cart");
    carts.forEach((el) => el.classList.add("is-content-updating"));
    this.updateCartStats();

    fetch("/cart")
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        const dataHtml = parseHtmlString(data);

        // insert the cart content
        carts.forEach((el) => {
          el.innerHTML = dataHtml.querySelector(".c-cart").innerHTML;
          el.classList.remove("is-content-updating");
        });

        // re-init line items
        this.initLineItem();
        this.initUpsell();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  },

  // line item level actions
  getLineItem: function (el) {
    const item = el.closest(".c-line-item");
    const key = item.dataset.itemKey;

    const object = {
      item: item,
      key: key,
    };

    return object;
  },
  getItemData: function (el) {
    // Convert to numbers - Shopify cart API requires numeric types, not strings
    const id = parseInt(el.querySelector('[name="id"]').value);
    const quantity = parseInt(el.querySelector('[name="quantity"]').value) || 1;

    // Check if one-time purchase is selected first
    const oneTimeToggle = el.querySelector(
      '[name="has_selling_plan"][value="no"]'
    );

    // If one-time is explicitly selected, don't send a selling plan
    if (oneTimeToggle && oneTimeToggle.checked) {
      const properties = {};
      try {
        el.querySelectorAll('[name*="properties["]').forEach((el) => {
          const propertyName = el.name.match(/\\[(.*?)\\]/);
          if (el.value) properties[propertyName[1]] = el.value;
        });
      } catch (err) {
        console.error(err);
      }

      return {
        id: id,
        quantity: quantity,
        selling_plan: null,
        properties: properties,
      };
    }

    // Logic to retrieve selling plan (only if one-time is NOT selected)
    // Priority 1: Managed hidden input (used by new-coffee-hero)
    const managedInput = el.querySelector(
      'input.standard-selling-plan[name="selling_plan"]'
    );
    let sellingPlan = null;

    if (managedInput) {
      sellingPlan = managedInput.value || null;
    } else {
      // Priority 2: Select element (fallback for shop cards and product-hero)
      const sellingPlanSelect = el.querySelector('select[name="selling_plan"]');

      if (sellingPlanSelect && !sellingPlanSelect.disabled) {
        if (!sellingPlanSelect.value && sellingPlanSelect.options.length > 0) {
          sellingPlanSelect.selectedIndex = 0;
        }
        if (sellingPlanSelect.value) {
          sellingPlan = sellingPlanSelect.value;
        }
      }
    }

    // Safety: Ensure sellingPlan is valid or null
    if (sellingPlan === "") sellingPlan = null;

    // Safety: if subscribe toggle is checked but no selling_plan, bail
    const subscribeToggle = el.querySelector(
      '[name="has_selling_plan"][value="yes"]'
    );

    if (subscribeToggle && subscribeToggle.checked && !sellingPlan) {
      console.warn(
        "[Cart] Subscribe selected but no selling plan found - aborting add to cart"
      );
      return null;
    }

    const properties = {};

    try {
      el.querySelectorAll('[name*="properties["]').forEach((el) => {
        const propertyName = el.name.match(/\\[(.*?)\\]/);
        if (el.value) properties[propertyName[1]] = el.value;
      });
    } catch (err) {
      console.error(err);
    }

    const object = {
      id: id,
      quantity: quantity,
      selling_plan: sellingPlan,
      properties: properties,
    };

    return object;
  },
  addItems: function ({
    items,
    updateCartContent = true,
    updateCartStats = false,
    callback,
  }) {
    console.log(
      "[addItems] Sending to cart API:",
      JSON.stringify({ items: items })
    );

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: items,
      }),
    })
      .then((response) => {
        console.log(
          "[addItems] Response status:",
          response.status,
          response.statusText
        );

        // Check if the response is OK
        if (!response.ok) {
          return response.text().then((errorText) => {
            console.error(
              "[addItems] Cart API returned error (text):",
              errorText
            );
            throw new Error(
              `Cart API error ${response.status}: ${response.statusText}`
            );
          });
        }

        // Clone response so we can read it twice if needed
        const responseClone = response.clone();

        // Try to parse as JSON - don't rely on content-type header
        return response.json().catch((parseError) => {
          // If JSON parse fails, get the text to see what we actually received
          return responseClone.text().then((responseText) => {
            console.error("[addItems] JSON parse error:", parseError);
            console.error(
              "[addItems] Response text:",
              responseText.substring(0, 500)
            );
            throw new Error(
              `Failed to parse cart response as JSON: ${parseError.message}`
            );
          });
        });
      })
      .then((data) => {
        // Check if selling_plan was actually applied
        if (data.items && data.items.length > 0) {
          data.items.forEach((item, index) => {
            if (!item.selling_plan_allocation) {
              console.warn(
                `[Cart] Warning: Item was added as one-time purchase instead of subscription. This may indicate Appstle app embed interference.`
              );
            }
          });
        }

        if (updateCartContent) this.updateCartContent();
        if (updateCartStats) this.updateCartStats();
        if (callback) callback();
      })
      .catch((error) => {
        console.error("[addItems] Error adding to cart:", error);
        alert(`Failed to add to cart: ${error.message}`);
        loader.complete(root); // Stop loading indicator
      });
  },
  updateLineItems: function ({
    items,
    updateCartContent = false,
    updateCartStats = true,
    callback,
  }) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        updates: items,
      }),
    })
      .then((response) => {
        response.json();
      })
      .then(() => {
        if (updateCartContent) this.updateCartContent();
        if (updateCartStats) this.updateCartStats();
        if (callback) callback();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  },

  // line item level updates
  initLineItem: function (e) {
    const getItemKeyWithQuantity = (itemKey, quantity) => {
      const items = {};
      items[itemKey] = quantity;

      return items;
    };

    const updateInfo = (lineItem, variantObject) => {
      cProductForm.updatePrice(lineItem, variantObject);
      cProductForm.updateQuantity(lineItem, variantObject);
      cProductForm.updateFormId(lineItem, variantObject);

      const thumb = lineItem.querySelector(".js-item-thumb img");
      if (variantObject.imageSrc && thumb) {
        thumb.src = variantObject.imageSrc;
        thumb.srcset = "";
      }
    };

    // quantity change
    const itemQuantity = document.querySelectorAll(
      '.c-line-item input[name="quantity"]'
    );
    itemQuantity.forEach((el) => {
      el.addEventListener("change", (e) => {
        const target = e.target.closest('input[name="quantity"]');
        const quantity = parseInt(target.value) || 1;
        const { key } = this.getLineItem(e.target);
        const items = getItemKeyWithQuantity(key, quantity);
        this.updateLineItems({
          items: items,
        });
      });
    });

    // remove item
    on("body", "click", ".c-line-item .js-item-remove-trigger", (e) => {
      const { item, key } = this.getLineItem(e.target);
      const items = getItemKeyWithQuantity(key, 0);

      this.updateLineItems({
        items: items,
      });
      item.classList.add("is-removed");
    });

    // clear minicart
    on("body", "click", ".js-minicart-clear", (e) => {
      let cart = document.querySelector(".c-cart");
      cart.classList.add("is-content-updating");
      this.updateCartStats();
      fetch("/cart/clear")
        .then((response) => {
          return response.text();
        })
        .then((data) => {
          const dataHtml = parseHtmlString(data);
          cart.innerHTML = dataHtml.querySelector(".c-cart").innerHTML;
          cart.classList.remove("is-content-updating");
          this.updateCartStats();
          // 	// re-init line items
          this.initLineItem();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });

    // change variant
    on("body", "change", ".c-line-item .js-variant-selector", (e) => {
      const target = e.target.closest(".js-variant-selector");
      const { item, key } = this.getLineItem(target);

      item.classList.add("is-variant-updating");
      loader.updateProgress(root);

      // find variant object
      const isInput = target.tagName == "INPUT";
      const variantId = isInput
        ? target.checked
          ? target.value
          : false
        : target.value;
      const variantsJson = validateJson(
        item.dataset.variantsJson.replace(/'/g, '"').trim()
      );
      const variantIndex = variantsJson.findIndex((object) => {
        return object.id === variantId;
      });
      const variantObject = variantsJson[variantIndex];

      // add item
      const itemData = this.getItemData(item);
      itemData["id"] = variantObject["id"];

      // if current quantity exceeds inventory
      if (parseInt(itemData["quantity"]) > variantObject["inventory"]) {
        // set quantity to inventory
        itemData["quantity"] = variantObject["inventory"];
      }

      this.addItems({
        items: [itemData],
        updateCartContent: false,
        updateCartStats: false,
        callback: () => {
          // when new item is added, remove current item
          const items = getItemKeyWithQuantity(key, 0);

          this.updateLineItems({
            items: items,
            callback: () => {
              // update item info
              fetch("/cart")
                .then((response) => {
                  return response.text();
                })
                .then((data) => {
                  const dataHtml = parseHtmlString(data);
                  const newLineItemKey = dataHtml.querySelector(
                    ".c-cart .c-line-item:last-child"
                  ).dataset.itemKey;

                  // update item key
                  item.dataset.itemKey = newLineItemKey;
                  // update item UI
                  updateInfo(item, variantObject);

                  // remove updating state
                  item.classList.remove("is-variant-updating");
                  loader.complete(root);
                })
                .catch((error) => {
                  console.error("Error:", error);
                });
            },
          });
        },
      });
    });
  },
  minicartClose: function () {
    root.classList.remove("is-minicart-active");
    history.replaceState(null, null, " ");
    scrollEnable();

    // Sync aria-expanded so screen readers know the minicart dialog closed.
    document
      .querySelectorAll(".js-minicart-toggle[aria-haspopup]")
      .forEach((btn) => btn.setAttribute("aria-expanded", "false"));

    // Return focus to the element that opened the cart
    if (this.lastActiveElement) {
      this.lastActiveElement.focus();
      this.lastActiveElement = null; // Clear the reference
    } else {
      // Fallback: focus the main cart button in the header
      const cartButton = document.querySelector(
        '.js-minicart-open, .js-minicart-toggle, [aria-label*="cart" i]'
      );
      if (cartButton) {
        cartButton.focus();
      }
    }
  },
  minicartOpen: function () {
    // Store the currently focused element before opening cart
    this.lastActiveElement = document.activeElement;

    root.classList.add("is-minicart-active");
    history.replaceState(null, null, "#cart");
    scrollDisable();

    // Sync aria-expanded so screen readers know the minicart dialog opened.
    document
      .querySelectorAll(".js-minicart-toggle[aria-haspopup]")
      .forEach((btn) => btn.setAttribute("aria-expanded", "true"));

    // Set focus to cart with improved timing and fallbacks
    const setCartFocus = () => {
      const cartContent = document.querySelector(".g-minicart__content");

      if (!cartContent) {
        setTimeout(setCartFocus, 50);
        return;
      }

      // Find the first focusable element within the cart
      const focusableElements = cartContent.querySelectorAll(
        'button:not([disabled]), [href]:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );

      if (focusableElements.length > 0) {
        focusableElements[0].focus();

        // Verify focus was set
        setTimeout(() => {
          if (document.activeElement !== focusableElements[0]) {
            cartContent.focus();
          }
        }, 10);
      } else {
        cartContent.focus();
      }
    };

    // Start trying to set focus after a longer delay to ensure cart is rendered
    setTimeout(setCartFocus, 200);
  },
  announceCartUpdate: function (message) {
    // Announce cart updates to screen readers via ARIA live region
    const liveRegion = document.querySelector("#cart-status");
    if (liveRegion) {
      liveRegion.textContent = message;
      // Clear the message after a short delay to reset for next announcement
      setTimeout(() => {
        liveRegion.textContent = "";
      }, 1000);
    }
  },
  initMinicart: function () {
    on("body", "click", ".js-minicart-close", this.minicartClose);
    on("body", "click", ".js-minicart-open", this.minicartOpen);

    on("body", "click", ".js-minicart-toggle", (e) => {
      root.classList.contains("is-minicart-active")
        ? this.minicartClose()
        : this.minicartOpen();
    });

    on("body", "keydown", "body", (e) => {
      if (e.key == "Escape") {
        this.minicartClose();
      }

      // Focus trapping within cart modal
      if (root.classList.contains("is-minicart-active") && e.key === "Tab") {
        const cartContent = document.querySelector(".g-minicart__content");
        if (cartContent) {
          const focusableElements = cartContent.querySelectorAll(
            'button:not([disabled]), [href]:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
          );

          if (focusableElements.length > 0) {
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];

            // Check if current focus is outside the cart
            const currentElementInCart = Array.from(focusableElements).includes(
              document.activeElement
            );

            // Only trap focus at the actual boundaries
            if (e.shiftKey) {
              // Shift + Tab: only intercept if on first element
              if (document.activeElement === firstElement) {
                e.preventDefault();
                lastElement.focus();
              }
              // Otherwise allow normal shift+tab behavior
            } else {
              // Tab: only intercept if on last element
              if (document.activeElement === lastElement) {
                e.preventDefault();
                firstElement.focus();
              }
              // Otherwise allow normal tab behavior
            }
          }
        }
      }
    });

    // trigger cart if url contains the hash
    if (location.hash == "#cart") {
      this.minicartOpen();
    }
  },

  initUpsell: function () {
    const upsellSection = document.querySelector(".js-upsell");
    const upsellItems = document.querySelectorAll(".js-upsell-item");
    const lineItems = document.querySelectorAll(
      ".js-line-item:not(.is-removed)"
    );

    let lineItemIDS = [];
    for (let item of lineItems) {
      lineItemIDS.push(item.getAttribute("data-item-id"));
    }

    let count = 0;

    for (let item of upsellItems) {
      if (!lineItemIDS.includes(item.getAttribute("data-item-id"))) {
        item.classList.add("is-active");
        count++;
      }
    }

    if (count > 0) {
      upsellSection.classList.add("is-active");
    }
  },

  applyDiscountCode: function (code) {
    fetch(`/cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        discount: code,
      }),
    })
      .then(async () => {
        window.location.hash = "#cart";
        window.location.reload();
      })
      .catch(() => {
        console.log("discount not applied");
      });
  },

  init: function () {
    // product form submissions
    on("body", "submit", 'form[action*="/cart/add"]', (e) => {
      // Explicitly ignore Upsell forms to prevent breaking them
      if (e.target.closest(".product-hero-upsell__form")) return;

      e.preventDefault();

      const form = e.target.closest("form");

      // If sold out, open waitlist instead of submitting
      if (
        form &&
        (form.dataset.available === "false" ||
          e.submitter?.hasAttribute("data-waitlist-trigger"))
      ) {
        const trigger =
          e.submitter || form.querySelector("[data-waitlist-trigger]");
        openWaitlistModal(trigger);
        return;
      }

      const item = this.getItemData(form);
      const discountCode = form.dataset.discountCode;

      // Check if getItemData returned null (happens when subscribe is checked but no plan selected)
      if (!item) {
        alert(
          "Please select a subscription frequency or choose one-time purchase"
        );
        return;
      }

      loader.updateProgress(root);
      this.addItems({
        items: [item],
        callback: () => {
          loader.complete(root);

          // If there's a discount code, redirect to apply it
          if (discountCode) {
            this.applyDiscountCode(discountCode);
          } else {
            this.minicartOpen();
          }
        },
      });
    });

    // initialize line items
    this.initLineItem();

    // initialize minicart
    this.initMinicart();

    // initialize upsell items
    this.initUpsell();
  },
};

// ***ACCOUNT PAGES***
const pAccount = {
  recoverClose: function () {
    root.classList.remove("is-account-recover-active");
    history.replaceState(null, null, " ");

    const inputRecoverEmail = document.querySelector("#account-recover-email");
    if (autoFocus && inputRecoverEmail) {
      inputRecoverEmail.blur();
    }
  },
  recoverOpen: function (autoFocus = true) {
    root.classList.add("is-account-recover-active");
    history.replaceState(null, null, "#recover");

    const inputRecoverEmail = document.querySelector("#account-recover-email");
    if (autoFocus && inputRecoverEmail) {
      inputRecoverEmail.focus();
    }
  },
  init: function () {
    on("body", "click", ".js-account-recover-close", this.recoverClose);
    on("body", "click", ".js-account-recover-open", this.recoverOpen);
    on("body", "click", ".js-account-recover-toggle", (e) => {
      root.classList.contains("is-account-recover-active")
        ? this.recoverClose()
        : this.recoverOpen();
    });

    // trigger recover if url contains the hash
    if (location.hash == "#recover") this.recoverOpen(false);
  },
};

// Standard selling plans - Global sync helper for new-coffee-hero
document.addEventListener("DOMContentLoaded", () => {
  const sellingPlanInputs = document.querySelectorAll(
    "input.standard-selling-plan"
  );
  const subscribeRadio = document.getElementById("has_selling_plan_yes");
  const oneTimeRadio = document.getElementById("has_selling_plan_no");
  const sellingPlanSelect = document.querySelector(
    ".psp-selling-plan-select, .psp select"
  );

  if (!sellingPlanInputs.length || !subscribeRadio || !oneTimeRadio) {
    return;
  }

  function updateSellingPlans() {
    const newValue =
      subscribeRadio.checked && sellingPlanSelect && !sellingPlanSelect.disabled
        ? sellingPlanSelect.value || ""
        : "";

    sellingPlanInputs.forEach((input) => {
      input.value = newValue;
    });
  }

  // Update when radio buttons change
  subscribeRadio.addEventListener("change", updateSellingPlans);
  oneTimeRadio.addEventListener("change", updateSellingPlans);

  // Update when select changes
  if (sellingPlanSelect) {
    sellingPlanSelect.addEventListener("change", updateSellingPlans);
  }

  // Run once on load
  updateSellingPlans();
});

// ***KLAVIYO ACCESSIBILITY SETUP***
const initKlaviyoAccessibility = () => {
  // Wait for Klaviyo to be available
  const checkKlaviyo = () => {
    if (typeof window.klaviyo !== "undefined") {
      // Listen for Klaviyo modal events
      document.addEventListener("click", (e) => {
        // Check if clicked element has the Klaviyo trigger class
        if (e.target.matches(".js-notify, .js-notify *")) {
          // Wait for modal to open, then set focus
          setTimeout(() => {
            const klaviyoModal = document.querySelector(
              '[data-testid="klaviyo-form-embed"], .klaviyo-form-embed, #klaviyo-form'
            );
            if (klaviyoModal) {
              klaviyoModal.focus();
              // Also announce that the notify form has opened
              cCart.announceCartUpdate(
                "Back in stock notification form opened"
              );
            }
          }, 500);
        }
      });
    } else {
      // Retry if Klaviyo isn't loaded yet
      setTimeout(checkKlaviyo, 1000);
    }
  };

  // Start checking for Klaviyo after page load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", checkKlaviyo);
  } else {
    checkKlaviyo();
  }
};

const openWaitlistModal = (trigger) => {
  const modal = document.querySelector("[data-waitlist-modal]");
  if (!modal) return;

  const productHandle = trigger?.dataset?.productHandle || "";
  const productTitle = trigger?.dataset?.productTitle || "";
  const productId = trigger?.dataset?.productId || "";

  // Store product data on modal for event tracking
  modal.dataset.waitlistProductHandle = productHandle;
  modal.dataset.waitlistProductTitle = productTitle;
  modal.dataset.waitlistProductId = productId;

  // Update heading display
  const headingEl = modal.querySelector(
    "[data-waitlist-product-title-heading]"
  );
  if (headingEl) {
    if (productTitle) {
      // Check if product title already starts with "The" (case-insensitive)
      const titleStartsWithThe = /^the\s+/i.test(productTitle);
      const headingText = titleStartsWithThe
        ? `${productTitle} is sold out.`
        : `The ${productTitle} is sold out.`;
      headingEl.textContent = headingText;
    } else {
      headingEl.textContent =
        modal.dataset.waitlistDefaultHeading || "Something New is Coming";
    }
  }

  const form = modal.querySelector("[data-waitlist-form]");
  if (form) form.classList.remove("is-success");
  modal.classList.remove("is-success");

  // remember focus to restore on close
  modal.dataset.waitlistLastFocus = "";
  if (document.activeElement && document.activeElement instanceof HTMLElement) {
    modal.dataset.waitlistLastFocus = "1";
    window.__waitlistLastActiveElement = document.activeElement;
  }

  modal.setAttribute("aria-hidden", "false");
  modal.classList.add("is-open");
  document.body.style.overflow = "hidden";

  const firstInput = modal.querySelector('input[type="email"]');
  if (firstInput) setTimeout(() => firstInput.focus(), 50);
};

const closeWaitlistModal = () => {
  const modal = document.querySelector("[data-waitlist-modal]");
  if (!modal) return;

  modal.setAttribute("aria-hidden", "true");
  modal.classList.remove("is-open");
  modal.classList.remove("is-success");
  document.body.style.overflow = "";

  if (
    window.__waitlistLastActiveElement &&
    typeof window.__waitlistLastActiveElement.focus === "function"
  ) {
    window.__waitlistLastActiveElement.focus();
    window.__waitlistLastActiveElement = null;
  }
};

const initWaitlistModal = () => {
  const modal = document.querySelector("[data-waitlist-modal]");
  if (!modal) return;

  // Open "default" waitlist modal via URL param on the coffee capsules collection.
  // Example: /collections/coffee-capsules?waitlist=true
  try {
    const url = new URL(window.location.href);
    const waitlistParam = url.searchParams.get("waitlist");
    const path = (url.pathname || "").replace(/\/$/, "");
    if (waitlistParam === "true" && path === "/collections/coffee-capsules") {
      // No trigger => no product context => default headline/message
      openWaitlistModal(null);

      // Remove the param so it won't re-open on refresh / subsequent navigation.
      url.searchParams.delete("waitlist");
      window.history.replaceState({}, "", url.toString());
    }
  } catch (e) {
    // no-op
  }

  on("body", "click", "[data-waitlist-trigger]", (e) => {
    const trigger = e.target.closest("[data-waitlist-trigger]");
    if (!trigger) return;
    e.preventDefault();
    openWaitlistModal(trigger);
  });

  on("body", "click", "[data-waitlist-close]", (e) => {
    e.preventDefault();
    closeWaitlistModal();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    if (!modal.classList.contains("is-open")) return;
    closeWaitlistModal();
  });

  // init Klaviyo AJAX binding (once)
  const initKlaviyo = () => {
    const form = modal.querySelector("#WaitlistForm");
    if (!form) return;

    if (typeof window.KlaviyoSubscribe === "undefined") {
      setTimeout(initKlaviyo, 250);
      return;
    }

    window.KlaviyoSubscribe.attachToForms("#WaitlistForm", {
      hide_form_on_success: true,
      extra_properties: {
        $source: "Waitlist Modal",
      },
      success: () => {
        // Track waitlist signup as an event (preserves all signups, not just latest)
        // This allows segmentation by "Joined Waitlist" event with product filters
        const productId = modal.dataset.waitlistProductId || "";
        const productHandle = modal.dataset.waitlistProductHandle || "";
        const productTitle = modal.dataset.waitlistProductTitle || "";

        // Track event for this specific product signup
        // This creates a history of all products they've joined waitlists for
        if (productId) {
          // Initialize _learnq if not already available
          if (typeof window._learnq === "undefined") {
            window._learnq = [];
          }

          window._learnq.push([
            "track",
            "Joined Waitlist",
            {
              ProductID: productId,
              ProductHandle: productHandle,
              ProductTitle: productTitle,
              $source: "Waitlist Modal",
            },
          ]);
        }

        form.classList.add("is-success");
        modal.classList.add("is-success");
        setTimeout(() => closeWaitlistModal(), 3000);
      },
    });
  };

  initKlaviyo();
};

// ***EXECUTE FUNCTIONS***
cWysiwygShopify.init();
cItemVariants.init();
cItemSellingPlan.init();
cItemQuantity.init();
cProductForm.init();
cCart.init();
pAccount.init();
cProductHero.init();
initKlaviyoAccessibility();
initWaitlistModal();